import { Currency } from "@redotech/money/currencies";
import * as zExt from "@redotech/rpc/ext";
import { createEnum } from "@redotech/zod/zod-enum";
import * as z from "zod/v4";

export const getPpuAbTestSummaryMetrics = {
  name: "getPpuAbTestSummaryMetrics" as const,
  input: z.object({ splitId: zExt.objectId() }),
  output: z.object({
    displayedAnnualizedRevenueImpact: z.object({
      value: z.string(),
      shopCurrency: createEnum(Currency),
    }),
    displayedTotalVisits: z.object({ value: z.string() }),
    displayedTestDurationDays: z.object({ value: z.string() }),
  }),
};
